import * as React from 'react';
import {useMemo, useState} from 'react';
import {Breadcrumb, Icon} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink} from 'react-router-dom';
import {
  InfinityScrollComponentProps,
  withInfinityScrollHandlers
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import RestClient from '../../../../lib/RestClient';
import Moment from 'react-moment';
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);

const FileNameComponent = (props: {fileName: string; read?: boolean; fileId: string; token: string;}) => {
  const [isRead, setIsRead] = useState(false);

  const nameTag = props.read || isRead ? <span>{props.fileName}</span> : <strong>{props.fileName}</strong>;
  const icon = props.read || isRead ? <Icon name="envelope open outline" /> : <Icon name="envelope outline" />;

  return <>{icon} <a href={RestClient.baseUrl + `mailbox/${props.fileId}?token=${encodeURIComponent(props.token)}`} download={props.fileName} onClick={() => setIsRead(true)} target="_blank" rel="noopener noreferrer">{nameTag}</a></>
};

const COLUMNS: ColumnDefinition[] = [
  {
    fieldName: 'filename',
    labelTranslationKey: 'MailBox.Filename',
    required: true,
    cellRender: (cell, row) => {
      return <FileNameComponent token={row.token} fileName={cell} fileId={row.storedFileId} read={row.data && row.data.read ? row.data.read : false} />
    }
  },
  {
    fieldName: 'createdAt',
    labelTranslationKey: 'MailBox.Date',
    required: true,
    cellRender: v => <Moment format={t("Common.DateTimeFormat")}>{v}</Moment>
  }
];

const getScrollParent = () => ContentContainer.instance.componentRef.current;

const PageComponent = (props: InfinityScrollComponentProps) => {
  if(props.loadingInitial) {
    return <LoadingContainer showLogo={false}/>;
  }
  return (
      <>
        <AnalyticsTracking page="mailbox" />
        <div className={"sticky-header"}>
          <div className={"ui container"}>
            <h3><Breadcrumb icon="right angle" sections={[
              {
                key: '1',
                as: NavLink,
                to: '/mailbox',
                content: `${t("Route.MailBox")}`, link: true
              }
            ]}/></h3>
            <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>

          </div>
        </div>


        <div className={"ui container responsivewrapper"}>
          <DataTable
              columns={COLUMNS}
              data={props.data}
              page={props.page}
              totalPages={props.totalPages}
              getScrollParent={getScrollParent}
              loadMore={props.loadMore}
              loading={props.loading}
          />
          <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
            <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
            </div>
          </div>
          <div style={{height: '2em'}}/>
        </div>
      </>
  )
};

const buildDataService = (authToken: string) => ({
  loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }): Promise<any> {
    return RestClient.get('mailbox', {
      token: authToken,
      sort: 'createdAt,desc',
      page: page,
      count: 50
    });
  }
});



const PageComponentWrapped = withInfinityScrollHandlers(PageComponent);

export default (props: {authToken: string}) => {
  const {authToken} = props;
  const dataService = useMemo(() => {
    return buildDataService(authToken);
  }, [authToken]);
  return <PageComponentWrapped
    dataService={dataService}
  />
};
